import React, { useCallback, useEffect, useRef, useState } from "react";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import { useNavigate, useParams } from "react-router-dom";
import { Stepper } from "primereact/stepper";
import { StepperPanel } from "primereact/stepperpanel";
import { Button } from "primereact/button";
import { useDropzone } from "react-dropzone";
import Countries_selector from "../Selector/Countries_selector";
import State_selector from "../Selector/State_selector";
import axios from "axios";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { format } from "date-fns";
import { useAlert } from "../alert/Alert_message";
import PhoneInput from "react-phone-number-input";
import { LiaCheckCircleSolid } from "react-icons/lia";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
const DragAndDrop = ({ accept, onFileDrop, label, multiple = true }) => {
  const onDrop = useCallback(
    (acceptedFiles) => {
      if (multiple) {
        onFileDrop(acceptedFiles);
      } else if (acceptedFiles.length > 0) {
        onFileDrop(acceptedFiles[0]);
      }
    },
    [onFileDrop, multiple],
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept,
    multiple,
  });

  return (
    <div
      {...getRootProps()}
      style={{
        border: "2px dashed #ddd",
        padding: "20px",
        textAlign: "center",
        cursor: "pointer",
        backgroundColor: isDragActive ? "#f0f8ff" : "white",
        marginBottom: "20px",
      }}
    >
      <input {...getInputProps()} />
      <p>{label}</p>
    </div>
  );
};

const Send_groupage = () => {
  const token = localStorage.getItem("token");
  const userRole = localStorage.getItem("userRole");
  const { showAlert } = useAlert();
  const port = process.env.REACT_APP_SECRET;
  const navigate = useNavigate();
  const stepperRef = useRef(null);
  const [currentStep, setCurrentStep] = useState(1);
  const alertShown = useRef(false);
  let email = null;
  const paypal_client_id = process.env.PAYPAL_CLIENT_ID;
  const paypal_currency = process.env.PAYPAL_CURRENCY;
  const storedUserInfo = localStorage.getItem("userInfo");

  if (storedUserInfo) {
    try {
      const userInfo = JSON.parse(storedUserInfo);
      email = userInfo?.email || null;
    } catch (error) {
      console.error("Invalid userInfo in localStorage");
      email = null;
    }
  }

  const { type } = useParams();
  useEffect(() => {
    if (!token || token.length === 0) {
      if (!alertShown.current) {
        showAlert("Login first!");
        alertShown.current = true;
        localStorage.setItem("redirectAfterLogin", `/send_groupage/${type}`);
        navigate("/login");
      }
    } else if (userRole === "admin") {
      if (!alertShown.current) {
        showAlert("Login as Individual!");
        alertShown.current = true;
        navigate("/login");
      }
    }
  }, []);

  const [selectedFiles, setSelectedFiles] = useState([]);

  const handleFileDrop = (files) => {
    if (selectedFiles.length + files.length > 10) {
      showAlert("You can only upload up to 10 images.");
      return;
    }

    const newFiles = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));

    setSelectedFiles((prevFiles) => [...prevFiles, ...newFiles]);
  };

  const handleRemoveImage = (index) => {
    setSelectedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const [showCalendar, setShowCalendar] = useState(false);
  const [state, setState] = useState([
    {
      startDate: new Date(),
      endDate: null,
      key: "selection",
    },
  ]);
  const startDateFormatted = format(state[0].startDate, "dd/MM/yyyy");
  const endDateFormatted = state[0].endDate
    ? format(state[0].endDate, "dd/MM/yyyy")
    : "Select End Date";

  const [picking_period, setPicking_period] = useState("");
  const [productName, setProductName] = useState("");
  const [productType, setProductType] = useState("");

  const [groupageCategories, setGroupageCategories] = useState([]);
  const [groupageObjects, setGroupageObjects] = useState([]);

  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedObject, setSelectedObject] = useState(null);

  const [categorySearch, setCategorySearch] = useState("");
  const [objectSearch, setObjectSearch] = useState("");

  const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);
  const [showObjectDropdown, setShowObjectDropdown] = useState(false);

  const [isOtherItem, setIsOtherItem] = useState(false);
  const [showOtherPopup, setShowOtherPopup] = useState(false);

  const [otherItem, setOtherItem] = useState({
    detail: "",
    length: "",
    width: "",
    height: "",
    volume: "",
    price: "",
  });

  const [box_dimension, setBox_dimension] = useState("");
  const [box_number, setBox_number] = useState("");
  const [box_description, setBox_description] = useState("");
  const [barrique_litter, setBarrique_litter] = useState("");
  const [barrique_number, setBarrique_number] = useState("");
  const [barrique_description, setBarrique_description] = useState("");
  const [Pweight, setPweight] = useState("");
  const [Pheight, setPheight] = useState("");
  const [Plength, setPlength] = useState("");
  const [Pwidth, setPwidth] = useState("");

  const [userName, setUserName] = useState("");
  const [userNumber, setUserNumber] = useState("");
  const [userEmail, setUserEmail] = useState(email);
  const [streetAddress, setStreetAddress] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [pick_up_date, setPick_up_date] = useState("");
  const [userCountry, setUserCountry] = useState("");
  const [userState, setUserState] = useState("");
  const [userCity, setUserCity] = useState("");
  const [userDescription, setUserDescription] = useState("");

  const [senderName, setSenderName] = useState("");
  const [senderNumber, setSenderNumber] = useState("");
  const [senderEmail, setSenderEmail] = useState("");
  const [senderStreetAddress, setSenderStreetAddress] = useState("");
  const [senderZipCode, setSenderZipCode] = useState("");
  const [departure_date, setDeparture_date] = useState("");
  const [senderCountry, setSenderCountry] = useState("");
  const [senderState, setSenderState] = useState("");
  const [senderCity, setSenderCity] = useState("");
  const [document, setDocument] = useState("");
  const [senderDescription, setSenderDescription] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");

  const [emailError, setEmailError] = useState(false);

  const Dimension = [
    { label: "Small(S) (30 x 20 x 10 cm)" },
    { label: "Medium(M) (40 x 30 x 20 cm)" },
    { label: "Large(L) (60 x 40 x 40 cm)" },
    { label: "Extra Large(XL) (80 x 60 x 60 cm)" },
  ];

  const Litter = [
    { label: "100 Litter" },
    { label: "200 Litter" },
    { label: "220 Litter" },
  ];

  const fetchGroupageCategories = async () => {
    try {
      const response = await axios.get(
        `${port}/send_groupage/groupage-item-category`,
        {
          headers: {
            Authorization: token,
          },
        },
      );

      if (response.data.status) {
        setGroupageCategories(response.data.message || []);
      } else {
        setGroupageCategories([]);
      }
    } catch (error) {
      console.log("Error fetching groupage categories:", error);
      setGroupageCategories([]);
    }
  };

  useEffect(() => {
    if (token) {
      fetchGroupageCategories();
    }
  }, []);

  const fetchGroupageObjects = async (category) => {
    try {
      const response = await axios.get(
        `${port}/send_groupage/groupage-item-info`,
        {
          headers: {
            Authorization: token,
          },
          params: {
            categories_fr: category.categories_fr,
            categories_en: category.categories_en,
          },
        },
      );

      if (response.data.status) {
        setGroupageObjects(response.data.message || []);
      } else {
        setGroupageObjects([]);
      }
    } catch (error) {
      console.log("Error fetching groupage objects:", error);
      setGroupageObjects([]);
    }
  };

  const handleCategorySelect = (category) => {
    setSelectedCategory(category);

    // setCategorySearch(`${category.categories_en} / ${category.categories_fr}`);
    setCategorySearch("");

    setShowCategoryDropdown(false);

    // Reset object selection
    setSelectedObject(null);
    setObjectSearch("");
    setGroupageObjects([]);

    fetchGroupageObjects(category);
  };

  const handleObjectSelect = (item) => {
    setSelectedObject(item);

    // setObjectSearch(`${item.object_en} / ${item.object_fr}`);
    setObjectSearch("");

    setShowObjectDropdown(false);
  };

  const handleOtherClick = () => {
    setShowCategoryDropdown(false);
    setShowObjectDropdown(false);

    setCategorySearch("");

    setShowOtherPopup(true);
  };

  const handleOtherCancel = () => {
    setShowOtherPopup(false);
  };

  const handleOtherItemChange = (e) => {
    const { name, value } = e.target;

    const updatedItem = {
      ...otherItem,
      [name]: value,
    };

    if (name === "length" || name === "width" || name === "height") {
      const length = Number(updatedItem.length);
      const width = Number(updatedItem.width);
      const height = Number(updatedItem.height);

      if (length > 0 && width > 0 && height > 0) {
        const volume = (length * width * height) / 1000000;

        updatedItem.volume = Number(volume.toFixed(6));
        updatedItem.price = Number((volume * 600).toFixed(2));
      } else {
        updatedItem.volume = "";
        updatedItem.price = "";
      }
    }

    setOtherItem(updatedItem);
  };

  const handleOtherAdd = () => {
    if (!otherItem.detail.trim()) {
      return;
    }

    if (!otherItem.length || !otherItem.width || !otherItem.height) {
      return;
    }

    setIsOtherItem(true);

    setSelectedCategory(null);
    setSelectedObject(null);

    setShowOtherPopup(false);
  };

  const validateStep1 = () => {
    // if (type === "item") {
    //   return productName;
    // } else if (type === "box") {
    //   return box_dimension && box_number;
    // } else {
    //   return barrique_litter && barrique_number;
    // }
    if (selectedObject) {
      return true;
    }

    if (isOtherItem) {
      const length = Number(otherItem.length);
      const width = Number(otherItem.width);
      const height = Number(otherItem.height);
      const volume = Number(otherItem.volume);
      const price = Number(otherItem.price);

      return (
        otherItem.detail.trim() !== "" &&
        length > 0 &&
        width > 0 &&
        height > 0 &&
        volume > 0 &&
        price > 0
      );
    }

    return false;
  };
  const handleEmailChange = (e) => {
    const value = e.target.value;
    setUserEmail(value);

    if (value === "" || isValidEmail(value)) {
      setEmailError(false);
    } else {
      setEmailError(true);
    }
  };
  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };
  const validateStep2 = () => {
    return (
      userName &&
      userNumber &&
      userEmail &&
      isValidEmail(userEmail) &&
      userCountry &&
      userState &&
      userCity
    );
  };
  const validateStep3 = () => {
    return senderName && senderNumber && senderCountry;
  };
  const isNextButtonDisabled = () => {
    if (currentStep === 1) return !validateStep1();
    if (currentStep === 2) return !validateStep2();
    if (currentStep === 3) return !validateStep3();
    return false;
  };
  const [isVisible, setIsVisible] = useState(false);
  const [congrat, setCongrat] = useState(false);

  const handleClose = () => {
    setIsVisible(false);
  };

  const CLOUD_NAME = "dizzgvtgf";
  const UPLOAD_PRESET = "groupage_img";

  const uploadImageToCloudinary = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", UPLOAD_PRESET);

    try {
      const response = await axios.post(
        `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
        formData,
      );
      return response.data.secure_url;
    } catch (err) {
      console.error("Cloudinary upload error:", err);
      return null;
    }
  };
  const uploadAllImages = async () => {
    try {
      const promises = selectedFiles.map((fileObj) =>
        uploadImageToCloudinary(fileObj.file),
      );
      const uploadedUrls = await Promise.all(promises);
      console.log("Uploaded image URLs:", uploadedUrls);
      return uploadedUrls;
    } catch (err) {
      console.error("Error uploading images:", err);
      return [];
    }
  };

  const [validate, setValidate] = useState(false);
  const submitData = async () => {
    setValidate(true);

    const uploadedImageUrls = await uploadAllImages();

    const formData = new FormData();

    // =========================================
    // GROUPAGE ITEM INFORMATION
    // =========================================

    if (isOtherItem) {
      // Category:
      // Other / Specify Detail
      formData.append("categories_en", `Other / ${otherItem.detail}`);

      // Object:
      // Specify Detail only
      formData.append("object_en", otherItem.detail);

      // Calculated volume
      formData.append("volume", otherItem.volume ?? "");

      // Calculated price
      formData.append("price", otherItem.price ?? "");

      // Other = true
      formData.append("other", "1");

      // Detail used by backend if needed
      formData.append("otherDetail", otherItem.detail);
    } else {
      // Normal category
      formData.append("categories_en", selectedCategory?.categories_en || "");

      // Normal object
      formData.append("object_en", selectedObject?.object_en || "");

      // Database item volume
      formData.append("volume", selectedObject?.volume ?? "");

      // Database item price
      formData.append("price", selectedObject?.price ?? "");

      // Other = false
      formData.append("other", "0");

      formData.append("otherDetail", "");
    }

    // =========================================
    // BOX INFORMATION
    // =========================================

    formData.append("box_dimension", box_dimension);
    formData.append("box_number", box_number);
    formData.append("box_description", box_description);

    // =========================================
    // BARRIQUE INFORMATION
    // =========================================

    formData.append("barrique_litter", barrique_litter);

    formData.append("barrique_number", barrique_number);

    formData.append("barrique_description", barrique_description);

    // =========================================
    // EXISTING PRODUCT DIMENSIONS
    // =========================================

    formData.append("Pweight", Pweight);
    formData.append("Pheight", Pheight);
    formData.append("Plength", Plength);
    formData.append("Pwidth", Pwidth);

    // =========================================
    // IMAGES
    // =========================================

    uploadedImageUrls.forEach((url) => {
      formData.append("imageUrls[]", url);
    });

    // =========================================
    // PICK-UP INFORMATION
    // =========================================

    formData.append("userName", userName);
    formData.append("userNumber", userNumber);
    formData.append("userEmail", userEmail);
    formData.append("userCountry", userCountry);
    formData.append("userState", userState);
    formData.append("userCity", userCity);
    formData.append("streetAddress", streetAddress);
    formData.append("zipCode", zipCode);
    formData.append("picking_period", picking_period);
    formData.append("userDescription", userDescription);

    // =========================================
    // DELIVERY INFORMATION
    // =========================================

    formData.append("senderName", senderName);
    formData.append("senderNumber", senderNumber);
    formData.append("senderEmail", senderEmail);
    formData.append("senderCountry", senderCountry);
    formData.append("senderState", senderState);
    formData.append("senderCity", senderCity);
    formData.append("senderStreetAddress", senderStreetAddress);
    formData.append("senderZipCode", senderZipCode);
    formData.append("departureDate", departure_date);
    formData.append("senderDescription", senderDescription);

    // =========================================
    // DOCUMENT
    // =========================================

    if (document) {
      formData.append("document", document);
    }

    try {
      const response = await axios.post(
        `${port}/send_groupage/send_groupage_submit`,
        formData,
        {
          headers: {
            Authorization: token,
          },
        },
      );

      // if (response.data.status === true) {
      //   setValidate(true);
      //   setIsVisible(false);
      //   setCongrat(true);
      // }
      if (response.data.status === true) {
        const groupageId = response.data.groupageId;

        if (!groupageId) {
          console.error("Groupage ID was not returned");
          return;
        }

        setValidate(true);

        // Create PayPal order
        const paymentResponse = await axios.post(
          `${port}/paypal/api/create-order`,
          {
            amount: otherItem?.price || selectedObject?.price,
            groupageId: groupageId,
          },
          {
            headers: {
              Authorization: token,
            },
          },
        );

        if (paymentResponse.data.approvalUrl) {
          // Save ID locally in case it is needed after redirect
          localStorage.setItem("pendingGroupageId", String(groupageId));

          localStorage.setItem("paypalOrderId", paymentResponse.data.id);

          // Redirect to PayPal
          window.location.href = paymentResponse.data.approvalUrl;
        }
      }
    } catch (error) {
      console.error("Error:", error);
      setValidate(false);
    }
  };
  return (
    <div className="d-flex flex-column align-items-center justify-content-center mt-5 pt-5">
      <div className="navbar-wrapper">
        <div className=" d-flex justify-content-center w-100">
          <Navbar />
        </div>
      </div>
      <div className="d-flex flex-column align-items-center justify-content-start w-100 mt-5">
        <section className="shipping-wrapper w-100">
          <div className="container-fluid">
            <div className="shipping-wrap-box w-100">
              <div className="title-head text-start">
                <h3>Shipping Information</h3>
              </div>
              <div className="shipping-wrap">
                <div className="row align-items-between justify-content-between w-100 mt-4 ps-3">
                  <div className="d-flex flex-column align-items-start justify-content-start col-md-12 col-12  border border-1 rounded-2 groupage-left">
                    <Stepper
                      linear
                      desabled
                      ref={stepperRef}
                      onStepChange={(step) => setCurrentStep(step)}
                      style={{ flexBasis: "auto", width: "100%" }}
                    >
                      <StepperPanel
                        header={
                          // type === "item"
                          //   ? "Item Information"
                          //   : type === "box"
                          //     ? "Box Information"
                          //     : "Barrique Information"
                          "Item Information"
                        }
                      >
                        <div className="shipping-form-wrapper">
                          <div className="row">
                            <div className="col-12">
                              <div className="border-2 border-dashed surface-border border-round surface-ground p-1">
                                <div className="text-center mb-3">
                                  <DragAndDrop
                                    accept="image/*"
                                    multiple={true}
                                    onFileDrop={handleFileDrop}
                                    label="Drag and drop images here, or click to select (Max: 10 images)"
                                  />
                                </div>

                                {selectedFiles.length > 0 && (
                                  <div className="d-flex flex-wrap justify-content-center gap-2">
                                    {selectedFiles.map((img, index) => (
                                      <div
                                        key={index}
                                        className="position-relative"
                                      >
                                        <img
                                          src={img.preview}
                                          alt={`Selected ${index}`}
                                          className="rounded border border-1 border-dark"
                                          style={{
                                            width: "80px",
                                            height: "80px",
                                            objectFit: "cover",
                                          }}
                                        />

                                        <button
                                          onClick={() =>
                                            handleRemoveImage(index)
                                          }
                                          className="btn btn-danger btn-sm position-absolute top-0 end-0 rounded-circle"
                                          style={{
                                            transform: "translate(50%, -50%)",
                                            width: "20px",
                                            height: "20px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            padding: "0",
                                          }}
                                        >
                                          ×
                                        </button>
                                      </div>
                                    ))}
                                  </div>
                                )}

                                <div className="row mt-4">
                                  {/* <div className="col-12 col-md-6 mb-4 text-start">
                                    <label className="shipping-input-label">
                                      Select Category{" "}
                                      <span className="text-danger">*</span>
                                    </label>

                                    <div className="position-relative">
                                      <input
                                        type="text"
                                        className="shipping-input-field"
                                        placeholder="Select category..."
                                        value={
                                          selectedCategory
                                            ? `${selectedCategory.categories_en} / ${selectedCategory.categories_fr}`
                                            : ""
                                        }
                                        readOnly
                                        onClick={() => {
                                          setShowCategoryDropdown(true);
                                          setShowObjectDropdown(false);
                                        }}
                                        style={{
                                          cursor: "pointer",
                                        }}
                                        autoComplete="off"
                                      />

                                      {showCategoryDropdown && (
                                        <div
                                          className="position-absolute bg-white border rounded shadow-sm w-100"
                                          style={{
                                            top: "100%",
                                            left: 0,
                                            zIndex: 1000,
                                            maxHeight: "300px",
                                            overflowY: "auto",
                                          }}
                                        >
                                          <div
                                            className="p-2 border-bottom bg-white"
                                            style={{
                                              position: "sticky",
                                              top: 0,
                                              zIndex: 2,
                                            }}
                                          >
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Search category..."
                                              value={categorySearch}
                                              onChange={(e) => {
                                                setCategorySearch(
                                                  e.target.value,
                                                );
                                              }}
                                              autoFocus
                                              autoComplete="off"
                                            />
                                          </div>

                                          {groupageCategories
                                            .filter((category) => {
                                              const search = categorySearch
                                                .toLowerCase()
                                                .trim();

                                              if (!search) {
                                                return true;
                                              }

                                              return (
                                                category.categories_fr
                                                  ?.toLowerCase()
                                                  .includes(search) ||
                                                category.categories_en
                                                  ?.toLowerCase()
                                                  .includes(search)
                                              );
                                            })
                                            .map((category, index) => (
                                              <div
                                                key={index}
                                                className="p-3 border-bottom"
                                                style={{
                                                  cursor: "pointer",
                                                }}
                                                onClick={() =>
                                                  handleCategorySelect(category)
                                                }
                                              >
                                                <strong>
                                                  {category.categories_en}
                                                </strong>

                                                <div className="text-secondary">
                                                  {category.categories_fr}
                                                </div>
                                              </div>
                                            ))}

                                          {groupageCategories.filter(
                                            (category) => {
                                              const search = categorySearch
                                                .toLowerCase()
                                                .trim();

                                              if (!search) {
                                                return true;
                                              }

                                              return (
                                                category.categories_fr
                                                  ?.toLowerCase()
                                                  .includes(search) ||
                                                category.categories_en
                                                  ?.toLowerCase()
                                                  .includes(search)
                                              );
                                            },
                                          ).length === 0 && (
                                            <div className="p-3 text-secondary">
                                              No category found
                                            </div>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </div> */}

                                  <div className="col-12 col-md-6 mb-4 text-start">
                                    <label className="shipping-input-label">
                                      Select Category{" "}
                                      <span className="text-danger">*</span>
                                    </label>

                                    {!isOtherItem ? (
                                      <div className="position-relative">
                                        <input
                                          type="text"
                                          className="shipping-input-field"
                                          placeholder="Select category..."
                                          value={
                                            selectedCategory
                                              ? `${selectedCategory.categories_en} / ${selectedCategory.categories_fr}`
                                              : ""
                                          }
                                          readOnly
                                          onClick={() => {
                                            setShowCategoryDropdown(true);
                                            setShowObjectDropdown(false);
                                          }}
                                          style={{
                                            cursor: "pointer",
                                          }}
                                          autoComplete="off"
                                        />

                                        {showCategoryDropdown && (
                                          <div
                                            className="position-absolute bg-white border rounded shadow-sm w-100"
                                            style={{
                                              top: "100%",
                                              left: 0,
                                              zIndex: 1000,
                                              maxHeight: "300px",
                                              overflowY: "auto",
                                            }}
                                          >
                                            {/* SEARCH + OTHER */}
                                            <div
                                              className="p-2 border-bottom bg-white"
                                              style={{
                                                position: "sticky",
                                                top: 0,
                                                zIndex: 2,
                                              }}
                                            >
                                              <div className="d-flex align-items-center gap-2">
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  placeholder="Search category..."
                                                  value={categorySearch}
                                                  onChange={(e) => {
                                                    setCategorySearch(
                                                      e.target.value,
                                                    );
                                                  }}
                                                  autoFocus
                                                  autoComplete="off"
                                                />

                                                <button
                                                  type="button"
                                                  className="btn btn-secondary"
                                                  onClick={handleOtherClick}
                                                  style={{
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  Other
                                                </button>
                                              </div>
                                            </div>

                                            {/* CATEGORY LIST */}
                                            {groupageCategories
                                              .filter((category) => {
                                                const search = categorySearch
                                                  .toLowerCase()
                                                  .trim();

                                                if (!search) {
                                                  return true;
                                                }

                                                return (
                                                  category.categories_fr
                                                    ?.toLowerCase()
                                                    .includes(search) ||
                                                  category.categories_en
                                                    ?.toLowerCase()
                                                    .includes(search)
                                                );
                                              })
                                              .map((category, index) => (
                                                <div
                                                  key={index}
                                                  className="p-3 border-bottom"
                                                  style={{
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() =>
                                                    handleCategorySelect(
                                                      category,
                                                    )
                                                  }
                                                >
                                                  <strong>
                                                    {category.categories_en}
                                                  </strong>

                                                  <div className="text-secondary">
                                                    {category.categories_fr}
                                                  </div>
                                                </div>
                                              ))}

                                            {groupageCategories.filter(
                                              (category) => {
                                                const search = categorySearch
                                                  .toLowerCase()
                                                  .trim();

                                                if (!search) {
                                                  return true;
                                                }

                                                return (
                                                  category.categories_fr
                                                    ?.toLowerCase()
                                                    .includes(search) ||
                                                  category.categories_en
                                                    ?.toLowerCase()
                                                    .includes(search)
                                                );
                                              },
                                            ).length === 0 && (
                                              <div className="p-3 text-secondary">
                                                No category found
                                              </div>
                                            )}
                                          </div>
                                        )}
                                      </div>
                                    ) : (
                                      /* OTHER ITEM DISPLAY */
                                      <div
                                        className="shipping-input-field d-flex align-items-center justify-content-between"
                                        style={{
                                          backgroundColor: "#f1f1f1",
                                          cursor: "default",
                                        }}
                                      >
                                        <span>Other / {otherItem.detail}</span>

                                        <button
                                          type="button"
                                          className="btn btn-sm btn-outline-secondary"
                                          onClick={() =>
                                            setShowOtherPopup(true)
                                          }
                                        >
                                          Edit
                                        </button>
                                      </div>
                                    )}
                                  </div>

                                  {/* <div className="col-12 col-md-6 mb-4 text-start">
                                    <label className="shipping-input-label">
                                      Select Object{" "}
                                      <span className="text-danger">*</span>
                                    </label>

                                    <div className="position-relative">
                                      <input
                                        type="text"
                                        className="shipping-input-field"
                                        placeholder={
                                          selectedCategory
                                            ? "Select object..."
                                            : "Select category first"
                                        }
                                        value={
                                          selectedObject
                                            ? `${selectedObject.object_en} / ${selectedObject.object_fr}`
                                            : ""
                                        }
                                        readOnly
                                        disabled={!selectedCategory}
                                        onClick={() => {
                                          if (selectedCategory) {
                                            setShowObjectDropdown(true);
                                            setShowCategoryDropdown(false);
                                          }
                                        }}
                                        style={{
                                          cursor: selectedCategory
                                            ? "pointer"
                                            : "not-allowed",
                                        }}
                                        autoComplete="off"
                                      />

                                      {showObjectDropdown &&
                                        selectedCategory && (
                                          <div
                                            className="position-absolute bg-white border rounded shadow-sm w-100"
                                            style={{
                                              top: "100%",
                                              left: 0,
                                              zIndex: 1000,
                                              maxHeight: "300px",
                                              overflowY: "auto",
                                            }}
                                          >
                                            <div
                                              className="p-2 border-bottom bg-white"
                                              style={{
                                                position: "sticky",
                                                top: 0,
                                                zIndex: 2,
                                              }}
                                            >
                                              <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Search object..."
                                                value={objectSearch}
                                                onChange={(e) => {
                                                  setObjectSearch(
                                                    e.target.value,
                                                  );
                                                }}
                                                autoFocus
                                                autoComplete="off"
                                              />
                                            </div>

                                            {groupageObjects
                                              .filter((item) => {
                                                const search = objectSearch
                                                  .toLowerCase()
                                                  .trim();

                                                if (!search) {
                                                  return true;
                                                }

                                                return (
                                                  item.object_fr
                                                    ?.toLowerCase()
                                                    .includes(search) ||
                                                  item.object_en
                                                    ?.toLowerCase()
                                                    .includes(search)
                                                );
                                              })
                                              .map((item, index) => (
                                                <div
                                                  key={index}
                                                  className="p-3 border-bottom"
                                                  style={{
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() =>
                                                    handleObjectSelect(item)
                                                  }
                                                >
                                                  <strong>
                                                    {item.object_en}
                                                  </strong>

                                                  <div className="text-secondary">
                                                    {item.object_fr}
                                                  </div>
                                                </div>
                                              ))}

                                            {groupageObjects.filter((item) => {
                                              const search = objectSearch
                                                .toLowerCase()
                                                .trim();

                                              if (!search) {
                                                return true;
                                              }

                                              return (
                                                item.object_fr
                                                  ?.toLowerCase()
                                                  .includes(search) ||
                                                item.object_en
                                                  ?.toLowerCase()
                                                  .includes(search)
                                              );
                                            }).length === 0 && (
                                              <div className="p-3 text-secondary">
                                                No object found
                                              </div>
                                            )}
                                          </div>
                                        )}
                                    </div>
                                  </div> */}

                                  <div className="col-12 col-md-6 mb-4 text-start">
                                    <label className="shipping-input-label">
                                      Select Object{" "}
                                      <span className="text-danger">*</span>
                                    </label>

                                    {!isOtherItem ? (
                                      <div className="position-relative">
                                        <input
                                          type="text"
                                          className="shipping-input-field"
                                          placeholder={
                                            selectedCategory
                                              ? "Select object..."
                                              : "Select category first"
                                          }
                                          value={
                                            selectedObject
                                              ? `${selectedObject.object_en} / ${selectedObject.object_fr}`
                                              : ""
                                          }
                                          disabled={!selectedCategory}
                                          readOnly
                                          onClick={() => {
                                            if (selectedCategory) {
                                              setShowObjectDropdown(true);
                                              setShowCategoryDropdown(false);
                                            }
                                          }}
                                          style={{
                                            cursor: selectedCategory
                                              ? "pointer"
                                              : "not-allowed",
                                          }}
                                          autoComplete="off"
                                        />

                                        {showObjectDropdown &&
                                          selectedCategory && (
                                            <div
                                              className="position-absolute bg-white border rounded shadow-sm w-100"
                                              style={{
                                                top: "100%",
                                                left: 0,
                                                zIndex: 1000,
                                                maxHeight: "300px",
                                                overflowY: "auto",
                                              }}
                                            >
                                              {/* SEARCH */}
                                              <div
                                                className="p-2 border-bottom bg-white"
                                                style={{
                                                  position: "sticky",
                                                  top: 0,
                                                  zIndex: 2,
                                                }}
                                              >
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  placeholder="Search object..."
                                                  value={objectSearch}
                                                  onChange={(e) => {
                                                    setObjectSearch(
                                                      e.target.value,
                                                    );
                                                  }}
                                                  autoFocus
                                                  autoComplete="off"
                                                />
                                              </div>

                                              {groupageObjects
                                                .filter((item) => {
                                                  const search = objectSearch
                                                    .toLowerCase()
                                                    .trim();

                                                  if (!search) {
                                                    return true;
                                                  }

                                                  return (
                                                    item.object_fr
                                                      ?.toLowerCase()
                                                      .includes(search) ||
                                                    item.object_en
                                                      ?.toLowerCase()
                                                      .includes(search)
                                                  );
                                                })
                                                .map((item, index) => (
                                                  <div
                                                    key={index}
                                                    className="p-3 border-bottom"
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                    onClick={() =>
                                                      handleObjectSelect(item)
                                                    }
                                                  >
                                                    <strong>
                                                      {item.object_en}
                                                    </strong>

                                                    <div className="text-secondary">
                                                      {item.object_fr}
                                                    </div>
                                                  </div>
                                                ))}

                                              {groupageObjects.filter(
                                                (item) => {
                                                  const search = objectSearch
                                                    .toLowerCase()
                                                    .trim();

                                                  if (!search) {
                                                    return true;
                                                  }

                                                  return (
                                                    item.object_fr
                                                      ?.toLowerCase()
                                                      .includes(search) ||
                                                    item.object_en
                                                      ?.toLowerCase()
                                                      .includes(search)
                                                  );
                                                },
                                              ).length === 0 && (
                                                <div className="p-3 text-secondary">
                                                  No object found
                                                </div>
                                              )}
                                            </div>
                                          )}
                                      </div>
                                    ) : (
                                      <div
                                        className="shipping-input-field"
                                        style={{
                                          backgroundColor: "#f1f1f1",
                                        }}
                                      >
                                        {otherItem.detail}
                                      </div>
                                    )}
                                  </div>
                                </div>

                                {showOtherPopup && (
                                  <div
                                    className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                                    style={{
                                      backgroundColor: "rgba(0, 0, 0, 0.5)",
                                      zIndex: 2000,
                                    }}
                                  >
                                    <div
                                      className="bg-white rounded shadow p-4"
                                      style={{
                                        width: "90%",
                                        maxWidth: "800px",
                                        maxHeight: "90vh",
                                        overflowY: "auto",
                                      }}
                                    >
                                      {/* <h4 className="mb-4">Specify / Detail</h4> */}

                                      {/* DETAIL */}
                                      <div className="mb-4">
                                        <label className="shipping-input-label">
                                          Specify / Detail{" "}
                                          <span className="text-danger">*</span>
                                        </label>

                                        <input
                                          type="text"
                                          className="form-control"
                                          name="detail"
                                          placeholder="Enter item detail..."
                                          value={otherItem.detail}
                                          onChange={handleOtherItemChange}
                                        />
                                      </div>

                                      {/* DIMENSIONS */}
                                      <div className="row">
                                        {/* LENGTH */}
                                        <div className="col-12 col-md-4 mb-3">
                                          <label className="shipping-input-label">
                                            Length (cm){" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>

                                          <input
                                            type="number"
                                            min="0"
                                            step="any"
                                            className="form-control"
                                            name="length"
                                            placeholder="Length"
                                            value={otherItem.length}
                                            onChange={handleOtherItemChange}
                                          />
                                        </div>

                                        {/* WIDTH */}
                                        <div className="col-12 col-md-4 mb-3">
                                          <label className="shipping-input-label">
                                            Width (cm){" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>

                                          <input
                                            type="number"
                                            min="0"
                                            step="any"
                                            className="form-control"
                                            name="width"
                                            placeholder="Width"
                                            value={otherItem.width}
                                            onChange={handleOtherItemChange}
                                          />
                                        </div>

                                        {/* HEIGHT */}
                                        <div className="col-12 col-md-4 mb-3">
                                          <label className="shipping-input-label">
                                            Height (cm){" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>

                                          <input
                                            type="number"
                                            min="0"
                                            step="any"
                                            className="form-control"
                                            name="height"
                                            placeholder="Height"
                                            value={otherItem.height}
                                            onChange={handleOtherItemChange}
                                          />
                                        </div>
                                      </div>

                                      {/* VOLUME + PRICE */}
                                      <div className="row">
                                        {/* VOLUME */}
                                        <div className="col-12 col-md-6 mb-3">
                                          <label className="shipping-input-label">
                                            Volume (m³)
                                          </label>

                                          <input
                                            type="text"
                                            className="form-control"
                                            value={otherItem.volume}
                                            readOnly
                                            style={{
                                              backgroundColor: "#e9ecef",
                                            }}
                                          />
                                        </div>

                                        {/* PRICE */}
                                        <div className="col-12 col-md-6 mb-3">
                                          <label className="shipping-input-label">
                                            Price (€600/m³)
                                          </label>

                                          <input
                                            type="text"
                                            className="form-control"
                                            value={
                                              otherItem.price
                                                ? `€ ${otherItem.price}`
                                                : ""
                                            }
                                            readOnly
                                            style={{
                                              backgroundColor: "#e9ecef",
                                            }}
                                          />
                                        </div>
                                      </div>

                                      {/* BUTTONS */}
                                      <div className="d-flex justify-content-end gap-2 mt-4">
                                        <button
                                          type="button"
                                          className="btn btn-secondary"
                                          onClick={handleOtherCancel}
                                        >
                                          Cancel
                                        </button>

                                        <button
                                          type="button"
                                          className="btn btn-primary"
                                          onClick={handleOtherAdd}
                                        >
                                          Add
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                )}

                                {(selectedObject || isOtherItem) && (
                                  <div className="row mt-2">
                                    {/* VOLUME */}
                                    <div className="col-12 col-md-6 mb-3 text-start">
                                      <label className="shipping-input-label">
                                        Volume
                                      </label>

                                      <input
                                        className="shipping-input-field"
                                        type="text"
                                        readOnly
                                        value={
                                          isOtherItem
                                            ? `${otherItem.volume} m³`
                                            : `${selectedObject.volume} m³`
                                        }
                                        style={{
                                          backgroundColor: "rgb(214, 214, 214)",
                                        }}
                                      />
                                    </div>

                                    {/* PRICE */}
                                    <div className="col-12 col-md-6 mb-3 text-start">
                                      <label className="shipping-input-label">
                                        Price (€600/m³)
                                      </label>

                                      <input
                                        className="shipping-input-field"
                                        type="text"
                                        readOnly
                                        value={
                                          isOtherItem
                                            ? `€ ${otherItem.price}`
                                            : `€ ${selectedObject.price}`
                                        }
                                        style={{
                                          backgroundColor: "rgb(214, 214, 214)",
                                        }}
                                      />
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* {type === "item" ? (
                          <>
                            <div className="shipping-form-wrapper">
                              <div className="row">
                                <div className="col-12">
                                  <div className="border-2 border-dashed surface-border border-round surface-ground p-1">
                                    <div className="text-center mb-3">
                                      <DragAndDrop
                                        accept="image/*"
                                        multiple={true}
                                        onFileDrop={handleFileDrop}
                                        label="Drag and drop images here, or click to select (Max: 10 images)"
                                      />
                                    </div>

                                    {selectedFiles.length > 0 && (
                                      <div className="d-flex flex-wrap justify-content-center gap-2">
                                        {selectedFiles.map((img, index) => (
                                          <div
                                            key={index}
                                            className="position-relative"
                                          >
                                            <img
                                              src={img.preview}
                                              alt={`Selected ${index}`}
                                              className="rounded border border-1 border-dark"
                                              style={{
                                                width: "80px",
                                                height: "80px",
                                                objectFit: "cover",
                                              }}
                                            />
                                            <button
                                              onClick={() =>
                                                handleRemoveImage(index)
                                              }
                                              className="btn btn-danger btn-sm position-absolute top-0 end-0 rounded-circle"
                                              style={{
                                                transform:
                                                  "translate(50%, -50%)",
                                                width: "20px",
                                                height: "20px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                padding: "0",
                                              }}
                                            >
                                              ×
                                            </button>
                                          </div>
                                        ))}
                                      </div>
                                    )}

                                    <div className="row mt-4">
                                      <div className="col-12 col-md-12 mb-2 text-start">
                                        <label className="shipping-input-label">
                                          Item Name{" "}
                                          <span className="text-danger">*</span>
                                        </label>
                                        <input
                                          className="shipping-input-field"
                                          type="text"
                                          value={productName}
                                          onChange={(e) =>
                                            setProductName(e.target.value)
                                          }
                                          placeholder="Enter the item name"
                                          style={{
                                            backgroundColor:
                                              "rgb(214, 214, 214)",
                                          }}
                                          autofill="on"
                                          required
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        ) : type === "box" ? (
                          <>
                            <div className="shipping-form-wrapper">
                              <div className="row">
                                <div className="col-12">
                                  <div className="border-2 border-dashed surface-border border-round surface-ground p-1">
                                    <div className="text-center mb-3">
                                      <DragAndDrop
                                        accept="image/*"
                                        multiple={true}
                                        onFileDrop={handleFileDrop}
                                        label="Drag and drop images here, or click to select (Max: 10 images)"
                                      />
                                    </div>

                                    {selectedFiles.length > 0 && (
                                      <div className="d-flex flex-wrap justify-content-center gap-2">
                                        {selectedFiles.map((img, index) => (
                                          <div
                                            key={index}
                                            className="position-relative"
                                          >
                                            <img
                                              src={img.preview}
                                              alt={`Selected ${index}`}
                                              className="rounded border border-1 border-dark"
                                              style={{
                                                width: "80px",
                                                height: "80px",
                                                objectFit: "cover",
                                              }}
                                            />
                                            <button
                                              onClick={() =>
                                                handleRemoveImage(index)
                                              }
                                              className="btn btn-danger btn-sm position-absolute top-0 end-0 rounded-circle"
                                              style={{
                                                transform:
                                                  "translate(50%, -50%)",
                                                width: "20px",
                                                height: "20px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                padding: "0",
                                              }}
                                            >
                                              ×
                                            </button>
                                          </div>
                                        ))}
                                      </div>
                                    )}

                                    <div className="row mt-4">
                                      <div className="col-12 col-md-6 mb-2 text-start">
                                        <label className="shipping-input-label">
                                          Box Dimension{" "}
                                          <span className="text-danger">*</span>
                                        </label>
                                        <select
                                          className="shipping-input-field"
                                          value={box_dimension}
                                          onChange={(e) =>
                                            setBox_dimension(e.target.value)
                                          }
                                        >
                                          <option value="" disabled hidden>
                                            Please choose category
                                          </option>
                                          {Dimension.map((dim, key) => (
                                            <>
                                              <option value={dim.label}>
                                                {dim.label}
                                              </option>
                                            </>
                                          ))}
                                        </select>
                                      </div>
                                      <div className="col-12 col-md-6 mb-2 text-start">
                                        <label className="shipping-input-label">
                                          Number of Boxes{" "}
                                          <span className="text-danger">*</span>
                                        </label>
                                        <input
                                          className="shipping-input-field"
                                          type="text"
                                          value={box_number}
                                          placeholder="Enter number of boxes"
                                          style={{
                                            backgroundColor:
                                              "rgb(214, 214, 214)",
                                          }}
                                          required
                                          onChange={(e) =>
                                            setBox_number(e.target.value)
                                          }
                                          onKeyDown={(e) => {
                                            if (
                                              e.key === "Backspace" ||
                                              e.key === "Delete" ||
                                              e.key === "ArrowLeft" ||
                                              e.key === "ArrowRight" ||
                                              e.key === "Tab"
                                            ) {
                                              return;
                                            }
                                            if (!/[0-9]/.test(e.key)) {
                                              e.preventDefault();
                                            }
                                          }}
                                        />
                                      </div>
                                    </div>

                                    <div className="d-flex flex-column text-align-start justify-content-start align-items-start w-100 mt-4">
                                      <lable className="shipping-input-label">
                                        Short info inside the box
                                      </lable>
                                      <textarea
                                        className="shipping-input-field"
                                        style={{
                                          backgroundColor: "rgb(214, 214, 214)",
                                        }}
                                        rows={4}
                                        placeholder="Short info inside the box....."
                                        onChange={(e) =>
                                          setBox_description(e.target.value)
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="shipping-form-wrapper">
                              <div className="row">
                                <div className="col-12">
                                  <div className="border-2 border-dashed surface-border border-round surface-ground p-1">
                                    <div className="text-center mb-3">
                                      <DragAndDrop
                                        accept="image/*"
                                        multiple={true}
                                        onFileDrop={handleFileDrop}
                                        label="Drag and drop images here, or click to select (Max: 10 images)"
                                      />
                                    </div>

                                    {selectedFiles.length > 0 && (
                                      <div className="d-flex flex-wrap justify-content-center gap-2">
                                        {selectedFiles.map((img, index) => (
                                          <div
                                            key={index}
                                            className="position-relative"
                                          >
                                            <img
                                              src={img.preview}
                                              alt={`Selected ${index}`}
                                              className="rounded border border-1 border-dark"
                                              style={{
                                                width: "80px",
                                                height: "80px",
                                                objectFit: "cover",
                                              }}
                                            />
                                            <button
                                              onClick={() =>
                                                handleRemoveImage(index)
                                              }
                                              className="btn btn-danger btn-sm position-absolute top-0 end-0 rounded-circle"
                                              style={{
                                                transform:
                                                  "translate(50%, -50%)",
                                                width: "20px",
                                                height: "20px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                padding: "0",
                                              }}
                                            >
                                              ×
                                            </button>
                                          </div>
                                        ))}
                                      </div>
                                    )}

                                    <div className="row mt-4">
                                      <div className="col-12 col-md-6 mb-2 text-start">
                                        <label className="shipping-input-label">
                                          Barrique Litter{" "}
                                          <span className="text-danger">*</span>
                                        </label>
                                        <select
                                          className="shipping-input-field"
                                          value={barrique_litter}
                                          onChange={(e) =>
                                            setBarrique_litter(e.target.value)
                                          }
                                        >
                                          <option value="" disabled hidden>
                                            Please choose category
                                          </option>
                                          {Litter.map((dim, key) => (
                                            <>
                                              <option value={dim.label}>
                                                {dim.label}
                                              </option>
                                            </>
                                          ))}
                                        </select>
                                      </div>
                                      <div className="col-12 col-md-6 mb-2 text-start">
                                        <label className="shipping-input-label">
                                          Number of Barrique{" "}
                                          <span className="text-danger">*</span>
                                        </label>
                                        <input
                                          className="shipping-input-field"
                                          type="text"
                                          value={barrique_number}
                                          placeholder="Enter number of barriques"
                                          style={{
                                            backgroundColor:
                                              "rgb(214, 214, 214)",
                                          }}
                                          required
                                          onChange={(e) =>
                                            setBarrique_number(e.target.value)
                                          }
                                          onKeyDown={(e) => {
                                            if (
                                              e.key === "Backspace" ||
                                              e.key === "Delete" ||
                                              e.key === "ArrowLeft" ||
                                              e.key === "ArrowRight" ||
                                              e.key === "Tab"
                                            ) {
                                              return;
                                            }
                                            if (!/[0-9]/.test(e.key)) {
                                              e.preventDefault();
                                            }
                                          }}
                                        />
                                      </div>
                                    </div>

                                    <div className="d-flex flex-column text-align-start justify-content-start align-items-start w-100 mt-4">
                                      <lable className="shipping-input-label">
                                        Short info inside the barrique
                                      </lable>
                                      <textarea
                                        className="shipping-input-field"
                                        style={{
                                          backgroundColor: "rgb(214, 214, 214)",
                                        }}
                                        rows={4}
                                        placeholder="Short info inside the barrique....."
                                        onChange={(e) =>
                                          setBarrique_description(
                                            e.target.value,
                                          )
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        )} */}
                      </StepperPanel>

                      <StepperPanel header="Pick-up Information">
                        <div
                          className=""
                          onClick={() => {
                            if (showCalendar === true) {
                              setShowCalendar(false);
                            }
                          }}
                        >
                          <div className="row mt-4 ">
                            <div className="col-12 col-md-4 text-start ">
                              <label className="shipping-input-label">
                                Full Name <span className="text-danger">*</span>
                              </label>
                              <input
                                className="shipping-input-field"
                                type="text"
                                value={userName}
                                onChange={(e) => setUserName(e.target.value)}
                                placeholder="Enter your full name"
                                style={{
                                  backgroundColor: "rgb(214, 214, 214)",
                                }}
                                required
                              />
                            </div>
                            <div className="col-12 col-md-4 text-start mt-4 mt-md-0 ">
                              <label className="shipping-input-label">
                                Contact Number (Whatsapp){" "}
                                <span className="text-danger">*</span>
                              </label>
                              <PhoneInput
                                international
                                className="shipping-input-field-contact"
                                style={{
                                  backgroundColor: "rgb(214, 214, 214)",
                                }}
                                defaultCountry="DE"
                                value={userNumber}
                                onChange={setUserNumber}
                              />
                              {/* <input className="shipping-input-field" type="tel" placeholder="Enter your contact number" value={userNumber} onChange={(e) => setUserNumber(e.target.value)} style={{ backgroundColor: 'rgb(214, 214, 214)' }} required /> */}
                            </div>
                            <div className="col-12 col-md-4 text-start mt-4 mt-md-0">
                              <label className="shipping-input-label">
                                Email Address
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                className="shipping-input-field"
                                type="email"
                                placeholder="Enter your email id"
                                readOnly
                                value={email}
                                // onChange={(e) => setUserEmail(e.target.value)}
                                onChange={handleEmailChange}
                                style={{
                                  backgroundColor: "rgb(214, 214, 214)",
                                  border: emailError
                                    ? "1px solid red"
                                    : "1px solid #b90303 !important",
                                }}
                                required
                              />
                              {emailError && (
                                <small style={{ color: " red" }}>
                                  <i>*Please enter a valid email address</i>
                                </small>
                              )}
                            </div>
                          </div>

                          <div className="row mt-4">
                            <div className="col-12 col-md-4 text-start">
                              <label className="shipping-input-label">
                                Country<span className="text-danger">*</span>
                              </label>
                              <Countries_selector
                                onSelectCountry={(value) => {
                                  setUserCountry(value);
                                  setSelectedCountry(value);
                                }}
                                value={userCountry}
                                paddingcount="12px 18px"
                                fontsizefont="15px"
                                bgcolor="#ebebeb"
                                bordercolor="1px solid #ebebeb"
                                borderradiuscount="6px"
                                required
                              />
                            </div>
                            <div className="col-12 col-md-4 text-start mt-4 mt-md-0">
                              <label className="shipping-input-label">
                                State<span className="text-danger">*</span>
                              </label>
                              <State_selector
                                selectedCountry={selectedCountry}
                                onSelectState={(value) => setUserState(value)}
                                value={userState}
                                paddingcount="12px 18px"
                                fontsizefont="15px"
                                bgcolor="#ebebeb"
                                bordercolor="1px solid #ebebeb"
                                borderradiuscount="6px"
                                required
                              />
                            </div>
                            <div className="col-12 col-md-4 text-start mt-4 mt-md-0">
                              <label className="shipping-input-label">
                                City<span className="text-danger">*</span>
                              </label>
                              <input
                                className="shipping-input-field"
                                type="text"
                                placeholder="Enter the city name"
                                style={{
                                  backgroundColor: "rgb(214, 214, 214)",
                                }}
                                value={userCity}
                                onChange={(e) => setUserCity(e.target.value)}
                                required
                              />
                            </div>
                          </div>

                          <div className="row mt-4">
                            <div className="col-12 col-md-4 text-start"></div>
                          </div>
                        </div>
                      </StepperPanel>

                      <StepperPanel header="Delivery Information">
                        <div className="row justify-content-center mt-4">
                          <div className="col-md-6  text-start">
                            <label className="shipping-input-label">
                              Receiver Full Name{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              className="shipping-input-field"
                              type="text"
                              value={senderName}
                              onChange={(e) => setSenderName(e.target.value)}
                              placeholder="Enter Receiver's full name"
                              required
                              style={{ backgroundColor: "rgb(214, 214, 214)" }}
                            />
                          </div>
                          <div className="col-md-6  text-start mt-4 mt-md-0">
                            <label className="shipping-input-label">
                              Receiver Contact Number (Whatsapp){" "}
                              <span className="text-danger">*</span>
                            </label>
                            <PhoneInput
                              international
                              className="shipping-input-field-contact"
                              style={{ backgroundColor: "rgb(214, 214, 214)" }}
                              defaultCountry="DE"
                              value={senderNumber}
                              onChange={setSenderNumber}
                            />
                          </div>
                        </div>
                        <div className="row justify-content-center mt-4">
                          <div className="col-md-6  text-start">
                            <label className="shipping-input-label">
                              Country <span className="text-danger">*</span>
                            </label>
                            <Countries_selector
                              onSelectCountry={(value) => {
                                setSenderCountry(value);
                                setSelectedCountry(value);
                              }}
                              value={senderCountry}
                              paddingcount="12px 18px"
                              fontsizefont="15px"
                              bgcolor="#ebebeb"
                              bordercolor="1px solid #ebebeb"
                              borderradiuscount="6px"
                              required
                            />
                          </div>
                          <div className="col-md-6 mt-4 mt-md-0 text-start">
                            <label className="shipping-input-label">
                              City <span className="text-danger">*</span>
                            </label>
                            <input
                              className="shipping-input-field"
                              type="text"
                              value={senderCity}
                              onChange={(e) => setSenderCity(e.target.value)}
                              placeholder="Enter City Name"
                              required
                              style={{ backgroundColor: "rgb(214, 214, 214)" }}
                            />
                          </div>
                        </div>
                      </StepperPanel>
                    </Stepper>

                    <div className="d-flex align-items-end justify-content-end w-100 ">
                      {currentStep !== 1 && (
                        <div className="d-flex justify-content-end p-2">
                          <Button
                            label="Back"
                            severity="secondary"
                            icon="pi pi-arrow-left"
                            className="btn rounded-2 "
                            style={{
                              backgroundColor: "transparent",
                              border: "1px solid #ccc",
                              color: "#1f1f1f",
                              fontWeight: "400",
                            }}
                            iconPos="center"
                            onClick={() => {
                              stepperRef.current.prevCallback();
                              setCurrentStep((prev) => prev - 1);
                              window.scrollTo({ top: 0 });
                              window.scrollTo({ top: 0 });
                            }}
                          />
                        </div>
                      )}
                      <div className="d-flex justify-content-end p-2">
                        <Button
                          label="Next"
                          icon="pi pi-arrow-right"
                          className="btn rounded-2 "
                          style={{
                            backgroundColor: "#1fa4e6",
                            color: "#fff",
                            fontWeight: "400",
                          }}
                          iconPos="center"
                          disabled={isNextButtonDisabled()}
                          onClick={() => {
                            if (currentStep < 3) {
                              stepperRef.current.nextCallback();
                              setCurrentStep((prev) => prev + 1);
                            } else {
                              setIsVisible(true);
                            }
                            window.scrollTo({ top: 0 });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {isVisible && (
          <PayPalScriptProvider
            options={{
              "client-id": `${paypal_client_id}`,
              currency: `${paypal_currency}`,
            }}
          >
            <div
              className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex justify-content-center align-items-center"
              style={{ zIndex: 1050 }}
            >
              <div
                className="position-relative bg-white p-4 rounded shadow-lg"
                style={{ width: "580px", height: "40rem", overflowY: "auto" }}
              >
                <button
                  className="btn-close position-absolute top-0 end-0 m-2"
                  onClick={handleClose}
                ></button>
                <div className="d-flex flex-column align-items-start w-100">
                  <strong className="fs-5">Review your order</strong>
                  <div className="d-flex flex-column align-items-start w-100 gap-2 pt-2 border-bottom border-2 pb-3">
                    <strong className="fs-6 pb-1">Product Information</strong>

                    {isOtherItem ? (
                      <>
                        <div className="d-flex justify-content-between w-100">
                          <span className="text-secondary">
                            Specify / Detail :
                          </span>

                          <span className="text-dark text-end">
                            {otherItem ? <>{otherItem.detail}</> : "N/A"}
                          </span>
                        </div>

                        <div className="d-flex justify-content-between w-100">
                          <span className="text-secondary">Length (cm) :</span>

                          <span className="text-dark text-end">
                            {otherItem ? <>{otherItem.length} cm</> : "N/A"}
                          </span>
                        </div>

                        <div className="d-flex justify-content-between w-100">
                          <span className="text-secondary">Width (cm) :</span>

                          <span className="text-dark text-end">
                            {otherItem ? <>{otherItem.width} cm</> : "N/A"}
                          </span>
                        </div>

                        <div className="d-flex justify-content-between w-100">
                          <span className="text-secondary">Height (cm) :</span>

                          <span className="text-dark text-end">
                            {otherItem ? <>{otherItem.height} cm</> : "N/A"}
                          </span>
                        </div>

                        <div className="d-flex justify-content-between w-100">
                          <span className="text-secondary">Volume :</span>

                          <span className="text-dark text-end">
                            {otherItem ? <>{otherItem.volume} m³</> : "N/A"}
                          </span>
                        </div>

                        <div className="d-flex justify-content-between w-100">
                          <span className="text-secondary">
                            Price (€600/m³) :
                          </span>

                          <span className="text-dark text-end">
                            {otherItem ? <>€{otherItem.price}</> : "N/A"}
                          </span>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="d-flex justify-content-between w-100">
                          <span className="text-secondary">Category :</span>

                          <span className="text-dark text-end">
                            {selectedCategory ? (
                              <>
                                {selectedCategory.categories_en}
                                {" / "}
                                {selectedCategory.categories_fr}
                              </>
                            ) : (
                              "N/A"
                            )}
                          </span>
                        </div>

                        <div className="d-flex justify-content-between w-100">
                          <span className="text-secondary">Object :</span>

                          <span className="text-dark text-end">
                            {selectedObject ? (
                              <>
                                {selectedObject.object_en}
                                {" / "}
                                {selectedObject.object_fr}
                              </>
                            ) : (
                              "N/A"
                            )}
                          </span>
                        </div>

                        <div className="d-flex justify-content-between w-100">
                          <span className="text-secondary">Volume :</span>

                          <span className="text-dark">
                            {selectedObject?.volume !== undefined &&
                            selectedObject?.volume !== null ? (
                              <>{selectedObject.volume} m³</>
                            ) : (
                              "N/A"
                            )}
                          </span>
                        </div>

                        <div className="d-flex justify-content-between w-100">
                          <span className="text-secondary">
                            Price (€600/m³) :
                          </span>

                          <span className="text-dark">
                            {selectedObject?.price !== undefined &&
                            selectedObject?.price !== null ? (
                              <>€ {selectedObject.price}</>
                            ) : (
                              "N/A"
                            )}
                          </span>
                        </div>
                      </>
                    )}
                  </div>
                  {/* {type === "item" ? (
                  <>
                    <div className="d-flex flex-column align-items-start w-100 gap-2 pt-2 border-bottom border-2 pb-3">
                      <strong className="fs-6 pb-1">Product Information</strong>
                      <div className="d-flex justify-content-between w-100">
                        <span className="text-secondary">Product Name :</span>{" "}
                        <span>
                          {productName ? <>{productName}</> : <>N/A</>}
                        </span>{" "}
                      </div>
                    </div>
                  </>
                ) : type === "box" ? (
                  <>
                    <div className="d-flex flex-column align-items-start w-100 gap-2 pt-2 border-bottom border-2 pb-3">
                      <strong className="fs-6 pb-1">Box Information</strong>
                      <div className="d-flex justify-content-between w-100">
                        <span className="text-secondary">Box Dimension :</span>{" "}
                        <span>
                          {box_dimension ? <>{box_dimension}</> : <>N/A</>}
                        </span>{" "}
                      </div>
                      <div className="d-flex justify-content-between w-100">
                        <span className="text-secondary">
                          Number of Boxes :
                        </span>{" "}
                        <span>
                          {box_number ? <>{box_number}</> : <>N/A</>}
                        </span>{" "}
                      </div>
                      <div className="d-flex justify-content-between w-100">
                        <span className="text-secondary">Box Info :</span>{" "}
                        <span>
                          {box_description ? <>{box_description}</> : <>N/A</>}
                        </span>{" "}
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="d-flex flex-column align-items-start w-100 gap-2 pt-2 border-bottom border-2 pb-3">
                      <strong className="fs-6 pb-1">
                        Barrique Information
                      </strong>
                      <div className="d-flex justify-content-between w-100">
                        <span className="text-secondary">
                          Barrique Litter :
                        </span>{" "}
                        <span>
                          {barrique_litter ? <>{barrique_litter}</> : <>N/A</>}
                        </span>{" "}
                      </div>
                      <div className="d-flex justify-content-between w-100">
                        <span className="text-secondary">
                          Number of Barrique :
                        </span>{" "}
                        <span>
                          {barrique_number ? <>{barrique_number}</> : <>N/A</>}
                        </span>{" "}
                      </div>
                      <div className="d-flex justify-content-between w-100">
                        <span className="text-secondary">Barrique Info :</span>{" "}
                        <span>
                          {barrique_description ? (
                            <>{barrique_description}</>
                          ) : (
                            <>N/A</>
                          )}
                        </span>{" "}
                      </div>
                    </div>
                  </>
                )} */}

                  <div className="d-flex flex-column align-items-start w-100 gap-2 pt-4 border-bottom border-2 pb-3">
                    <strong className="fs-6 pb-1">Pick Up Information</strong>
                    <div className="d-flex justify-content-between w-100">
                      {" "}
                      <span className="text-secondary">Full Name :</span>{" "}
                      <span className="text-dark">
                        {" "}
                        {userName ? <span>{userName}</span> : <span>N/A</span>}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between w-100">
                      {" "}
                      <span className="text-secondary">
                        Contact Number :
                      </span>{" "}
                      <span className="text-dark">
                        {" "}
                        {userNumber ? (
                          <span>{userNumber}</span>
                        ) : (
                          <span>N/A</span>
                        )}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between w-100">
                      {" "}
                      <span className="text-secondary">Email ID :</span>{" "}
                      <span className="text-dark">
                        {" "}
                        {userEmail ? (
                          <span>{userEmail}</span>
                        ) : (
                          <span>N/A</span>
                        )}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between w-100">
                      {" "}
                      <span className="text-secondary">Country :</span>{" "}
                      <span className="text-dark">
                        {" "}
                        {userCountry ? (
                          <span>{userCountry}</span>
                        ) : (
                          <span>N/A</span>
                        )}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between w-100">
                      {" "}
                      <span className="text-secondary">State :</span>{" "}
                      <span className="text-dark">
                        {" "}
                        {userState ? (
                          <span>{userState}</span>
                        ) : (
                          <span>N/A</span>
                        )}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between w-100">
                      {" "}
                      <span className="text-secondary">City :</span>{" "}
                      <span className="text-dark">
                        {" "}
                        {userCity ? <span>{userCity}</span> : <span>N/A</span>}
                      </span>
                    </div>
                  </div>

                  <div className="d-flex flex-column align-items-start w-100 gap-2 pt-4 pb-3">
                    <strong className="fs-6 pb-1">Delivery Information</strong>
                    <div className="d-flex justify-content-between w-100">
                      {" "}
                      <span className="text-secondary">Full Name :</span>{" "}
                      <span className="text-dark">
                        {" "}
                        {senderName ? (
                          <span>{senderName}</span>
                        ) : (
                          <span>N/A</span>
                        )}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between w-100">
                      {" "}
                      <span className="text-secondary">
                        Contact Number :
                      </span>{" "}
                      <span className="text-dark">
                        {" "}
                        {senderNumber ? (
                          <span>{senderNumber}</span>
                        ) : (
                          <span>N/A</span>
                        )}
                      </span>
                    </div>

                    <div className="d-flex justify-content-between w-100">
                      {" "}
                      <span className="text-secondary">Country :</span>{" "}
                      <span className="text-dark">
                        {" "}
                        {senderCountry ? (
                          <span>{senderCountry}</span>
                        ) : (
                          <span>N/A</span>
                        )}
                      </span>
                    </div>

                    <div className="d-flex justify-content-between w-100">
                      {" "}
                      <span className="text-secondary">City :</span>{" "}
                      <span className="text-dark">
                        {" "}
                        {senderCity ? (
                          <span>{senderCity}</span>
                        ) : (
                          <span>N/A</span>
                        )}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="mt-4 p-3 rounded border bg-primary bg-opacity-10">
                          <p class="mb-0 text-primary small text-start">
                            🔒 <strong>Privacy notice:</strong> A listing fee of €5 will be charged to publish your shipment on the Novibiz platform. Once your shipment is live, registered transporters will be able to contact you directly with their offers.
                          </p>
                        </div>
                <div className="w-100 pt-4">
                  {/* <button
                    className="btn btn-warning w-100 mt-3 paypal-btn-user"
                    onClick={handleCustomPayment}
                  >
                    Unlock Transporter Details with €5
                  </button> */}
                  <button
                    className="btn btn-warning w-100 mt-3 paypal-btn-user"
                    // className="btn btn-primary w-100"
                    disabled={validate}
                    onClick={() => {
                      submitData();
                      setValidate(true);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </PayPalScriptProvider>
        )}

        {congrat && (
          <>
            <div
              className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex justify-content-center align-items-center"
              style={{ zIndex: 1050 }}
            >
              <div
                className="position-relative bg-white p-4 rounded shadow-lg"
                style={{ width: "580px", height: "25rem" }}
              >
                <div className="d-flex align-items-center justify-content-center w-100">
                  <LiaCheckCircleSolid
                    className="mb-3"
                    style={{ color: "#1ba300", fontSize: "7rem" }}
                  />
                </div>

                <div className="title-head">
                  <h3 style={{ color: " #1ba300" }}>
                    Request Submitted Successfully
                  </h3>
                </div>

                <div className="success-des-wrap">
                  <p>
                    You will receive offers from multiple transporters on your
                    registered email address and dashboard
                  </p>
                </div>

                <div className="success-button">
                  <button
                    className="btn-success"
                    onClick={() => navigate("/dashboard")}
                  >
                    Go To Dashboard
                  </button>
                </div>
              </div>
            </div>
          </>
        )}
      </div>

      <div className="w-100">
        <Footer />
      </div>
    </div>
  );
};

export default Send_groupage;
